import './CertificationsFooter.scss';
import { ReactComponent as Esomar } from "./../../assets/certifications/login/esomar.svg"
import { ReactComponent as ISO27001 } from "./../../assets/certifications/login/iso27001.svg"
import { ReactComponent as ISO2052 } from "./../../assets/certifications/login/iso20252.svg"
import { ReactComponent as Insights } from "./../../assets/certifications/login/insights.svg"
import { ReactComponent as Hipaa } from "./../../assets/certifications/login/hipaa.svg"
import classNames from "classnames"

function CertificationsFooter({ isLoginPage = false }) {
  let logoClassName = isLoginPage ? 'LoginIcon ml-5' : 'Icon ml-6'
  let logoArray = [
    // <Hipaa className={logoClassName} />,
    <ISO27001 className={logoClassName} />,
    <ISO2052 className={logoClassName} />,
    <Esomar className={logoClassName} />,
    // <Insights className={logoClassName} />
  ]


  return (
    <div className={classNames("CertificationsFooter flex align-items-center")} >
      <h2 className={classNames("TextArea uppercase  mb-0 line-height-3", { LoginPage: isLoginPage, 'text-base font-medium': !isLoginPage, 'text-sm font-normal': isLoginPage })} style={{ lineHeight: '1rem', letterSpacing: 1.5 }}>Memberships & <br />Certifications</h2>
      <div className='flex justify-content-evenly align-items-center'>

        {logoArray.map((el, _id) => <div key={_id} >
          {el}
        </div>)}
      </div>
    </ div>
  )
}

export default CertificationsFooter